import { Plus, Trash2, Users } from "lucide-react";
import { Card } from "../Field";

const cols = [
  { key: "ime", label: "Ime i prezime", w: "w-[18%]" },
  { key: "dolazak", label: "Vrijeme dolaska", w: "w-[12%]" },
  { key: "odlazak", label: "Vrijeme odlaska", w: "w-[12%]" },
  { key: "isprava", label: "Pokazana ID isprava", w: "w-[18%]" },
  { key: "razlog", label: "Razlog posjete", w: "w-[20%]" },
  { key: "osoba", label: "Osoba koju posjećuje", w: "w-[20%]" },
];

export default function PosjetiteljiTab({ record, update }) {
  const rows = record.posjetitelji;

  const setCell = (i, key, val) => {
    const next = rows.map((r, idx) => (idx === i ? { ...r, [key]: val } : r));
    update({ posjetitelji: next });
  };
  const addRow = () => update({ posjetitelji: [...rows, { ime: "", dolazak: "", odlazak: "", isprava: "", razlog: "", osoba: "" }] });
  const removeRow = (i) => update({ posjetitelji: rows.filter((_, idx) => idx !== i) });

  return (
    <Card title="Evidencija posjetitelja u školi" subtitle="Svaka osoba koja ulazi u školu upisuje se u tablicu" badge={`${rows.length} ${rows.length === 1 ? "posjetitelj" : "posjetitelja"}`}>
      {rows.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50/60 py-10 text-center" data-testid="posjetitelji-empty-state">
          <Users className="mb-2 h-8 w-8 text-slate-300" />
          <p className="text-sm font-medium text-slate-500">Još nema evidentiranih posjetitelja</p>
          <p className="text-xs text-slate-400">Dodajte prvi unos gumbom ispod</p>
        </div>
      ) : (
        <div className="overflow-x-auto -mx-2 px-2">
          <table className="w-full min-w-[860px] border-separate border-spacing-0">
            <thead>
              <tr>
                {cols.map((c) => (
                  <th key={c.key} className={`${c.w} border-b border-slate-200 pb-2 pr-2 text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500`}>{c.label}</th>
                ))}
                <th className="border-b border-slate-200 pb-2 w-10"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className="group">
                  {cols.map((c) => (
                    <td key={c.key} className="border-b border-slate-100 py-1.5 pr-2">
                      <input
                        data-testid={`posjetitelj-${i}-${c.key}`}
                        value={row[c.key] || ""}
                        onChange={(e) => setCell(i, c.key, e.target.value)}
                        className="w-full rounded-lg border border-slate-200 bg-white px-2.5 py-2 text-sm outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-100"
                      />
                    </td>
                  ))}
                  <td className="border-b border-slate-100 py-1.5">
                    <button
                      data-testid={`posjetitelj-${i}-obrisi-btn`}
                      onClick={() => removeRow(i)}
                      title="Obriši red"
                      className="rounded-lg p-2 text-slate-400 transition-colors hover:bg-red-50 hover:text-red-500"
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <button
        data-testid="posjetitelj-dodaj-red-btn"
        onClick={addRow}
        className="inline-flex items-center gap-2 rounded-xl bg-sky-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-sky-700 active:scale-[0.98]"
      >
        <Plus className="h-4 w-4" /> Dodaj posjetitelja
      </button>
    </Card>
  );
}
